import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-using-the-course-support-article',
    template: `
        <ng-container i18n="@@support.articles.usingTheCourse">
            <p>The course is divided into lessons. Each lesson contains one or several videos, exercises and games. On the overview page of the course you can see how many exercises there are in each lesson, and how many you have already completed.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/lesson.png" />
                <figcaption>This lesson consists of four exercises, two of which you have already completed.</figcaption>
            </figure>
            <p>You can repeat each exercise as many times as you want. We recommend that you successfully complete each exercise before moving on to the next. You are of course free to skip exercises.</p>
            <p>You can go to a specific exercise within a lesson with the buttons at the bottom of the screen.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/lessonNavigation.png" />
                <figcaption>Hold the mouse cursor over a button to see the name of the exercise. You can also see the number of stars you have achieved.</figcaption>
            </figure>
        </ng-container>
    `
})
export class UsingTheCourseSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
